/**
 * Fichier racine de MyOpen
 */
import MyOpenPage from "./MyOpenPage";
import ReactDOM from "react-dom";

ReactDOM.render(<MyOpenPage />, document.getElementById("root"));
